// extracted by mini-css-extract-plugin
export var card = "_ov-0";
export var content = "_ov-2";
export var details = "_ov-3";
export var icon = "_ov-1";
export var iconBlue = "_ov-5";
export var iconBrand = "_ov-4";
export var iconGrayBlue = "_ov-6";
export var iconGreen = "_ov-7";
export var iconIndigo = "_ov-8";
export var iconOrange = "_ov-9";
export var iconPurple = "_ov-a";
export var iconRed = "_ov-b";
export var iconWarning = "_ov-c";